import React from "react";
import {useOfferingOptions} from "../../../hooks/use-offering";
import {NewOfferingHeader} from "./header";
import {OptionsGrid} from "./options/options";
import {Container} from "./new-offering.style";

export const colors = [
  "#FFFBE6",
  "#E7EDE1",
  "#D6E4FF",
  "#F3E9FE",
  "#FCF2E8",
  "#DFFCD8",
  "#E1F6F5",
  "#E0F5E3",
];
export const NewOfferingComponent: React.FC = () => {
  const {
    bottomSectionOptions,
    handleCancel,
    handleContinue,
    handleOptionClick,
    selected,
    topSectionOptions,
    contextHolder,
  } = useOfferingOptions();

  return (
    <Container>
      {contextHolder}
      <NewOfferingHeader
        title="What do you want to create?"
        onCancel={handleCancel}
        onContinue={handleContinue}
        canContinue={!!selected}
      />
      <OptionsGrid
        colors={colors}
        options={topSectionOptions}
        onOptionClick={handleOptionClick}
        selected={selected}
      />
      {bottomSectionOptions.length > 0 && (
        <OptionsGrid
          selected={selected}
          colors={colors}
          options={bottomSectionOptions}
          title="You can also create"
          onOptionClick={handleOptionClick}
        />
      )}
    </Container>
  );
};
